
import PropTypes from "prop-types";
export const SolutionItem = ({image, titleheader,title}) => {
    return (
        <div className="flex group hoverGroup">
        <div className="flex-1 flex flex-col">
            <img className="w-[70px]" src={image}/>
            <div className="mt-[20px]">
                <h1 className="text-[--color-title]   group-hover:animate-text  hoverTextSolution text-[24px] font-bold">
                    {titleheader}
                </h1>
                <p className="text-[15px]  max-w-[364px] sm:max-w-none text-[--color-text]">{title}</p>
                    
            </div>

        </div>
    </div>
    )
}
SolutionItem.propTypes = {
    image: PropTypes.string,
    titleheader: PropTypes.string,
    title: PropTypes.string,
    
  };